import { Controller } from "@hotwired/stimulus";

// Names the file chosen in shared/dropzone_without_direct_upload, and
// highlights the area while a file is dragged over it.
export default class extends Controller {
  static targets = ["input", "text"];
  static classes = ["dragging"];

  show() {
    const file = this.inputTarget.files[0];
    if (file) this.textTarget.textContent = file.name;
  }

  highlight() {
    this.element.classList.add(...this.draggingClasses);
  }

  unhighlight() {
    this.element.classList.remove(...this.draggingClasses);
  }
}
